import { _x, sprintf } from '@wordpress/i18n';

document.addEventListener('findstrLoaded', () => {
  const findstr = window.findstr;
  const fortFields = document.querySelectorAll('.findstr-field-sort');

  if (findstr && 0 < fortFields.length) {
    findstr.hooks.addFilter(
      'findstrSortLabel',
      'policeSort',
      (sortLabel, option, direction) => {
        let label = sortLabel;
        const dateDirectionLabel =
          direction === 'asc'
            ? _x('(least recent)', 'Sort datetime direction label', 'vtx')
            : _x('(most recent)', 'Sort datetime direction label', 'vtx');
        const alphaDirectionLabel =
          direction === 'asc'
            ? _x('(A-Z)', 'Sort alphabetic direction label', 'vtx')
            : _x('(Z-A)', 'Sort alphabetic direction label', 'vtx');

        switch (option) {
          case 'post_date':
            label = sprintf(
              /* translators: %s: Sort direction label */
              _x('Date %s', 'Sort label', 'vtx'),
              dateDirectionLabel
            );
            break;
          case 'post_title':
            label = sprintf(
              /* translators: %s: Sort direction label */
              _x('Title %s', 'Sort label', 'vtx'),
              alphaDirectionLabel
            );
            break;
        }

        return label;
      }
    );
  }
});
